import {
  takeEvery, all, call, put, select,
} from 'redux-saga/effects';

import {
  apiGetImage,
} from './api';

import {
  getImageActionTypes,
  getImageActions,
} from './actions';

function* fetchImage(action) {
  try {
    const { id, name } = action;
    yield put(getImageActions.request(id));
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetImage(id, companyId));
    const responseBlob = yield response.blob();
    let contentType;
    let mimeType = 'image/*';
    if (name.toLowerCase()
      .endsWith('pdf')) {
      contentType = 'pdf';
      mimeType = 'application/pdf';
    } else {
      contentType = 'image';
    }

    const file = new Blob([responseBlob], { type: mimeType });

    const url = window.URL || window.webkitURL;
    const src = url.createObjectURL(file);

    yield put(getImageActions.success(id, src, contentType));
  } catch (error) {
    console.error(error);
    yield put(getImageActions.error(error));
  }
}

function* watchGetTransactions() {
  yield takeEvery(getImageActionTypes.common, fetchImage);
}

export default function* root() {
  yield all([
    watchGetTransactions(),
  ]);
}
